import React from 'react';
import { Button, Input } from 'antd';

export function buildCommandPasswordTab(context) {
  const { shouldShowPage, commandPwd, newPwd, setNewPwd, pwdMsg, showCommandPwd, setShowCommandPwd, handleSavePwd } = context;
  if (!shouldShowPage('指挥系统密码')) return null;

  return {
    key: 'command_password',
    label: '指挥系统密码',
    children: (
      <div>
        <h3>指挥系统密码</h3>
        <p style={{ color: '#666', marginBottom: 12 }}>
          密码仅写入时加密存储，界面不回显明文。状态：
          <strong style={{ marginLeft: 6, color: commandPwd ? '#0f766e' : '#b45309' }}>
            {commandPwd ? '已配置' : '未配置'}
          </strong>
        </p>
        <div style={{ marginBottom: 16 }}>
          <Input.Password
            placeholder="输入新密码（至少 4 位）"
            value={newPwd}
            onChange={(e) => setNewPwd(e.target.value)}
            style={{ width: 300, marginRight: 8 }}
            visibilityToggle={{
              visible: showCommandPwd,
              onVisibleChange: setShowCommandPwd
            }}
          />
          <Button type="primary" onClick={handleSavePwd}>更新密码</Button>
        </div>
        {pwdMsg && <div style={{ color: pwdMsg.includes('成功') ? 'green' : 'red' }}>{pwdMsg}</div>}
      </div>
    )
  };
}
